<template>
  <div class="read-recommend">
    <div class="header">
      <TopBar :title="title" color="white" white="true" />
    </div>
    <div class="content">
      <div class="content-top" v-if="loading">
        <van-loading size="35" />
      </div>
      <div v-else>
        <div class="content-top" v-show="list[0].userName">
          <div class="content-top-img-left">
            <van-image round style=" width: 1.2rem;
          height: 1.2rem;
          border-radius: 50%;" :src="list[1].avatarUrl"
              error-icon="http://www.weopinions.com/images/photo/default.gif" />
            <img class='tara1-icon' src="../../assets/img/银冠.png" alt="">
            <p style="text-align: center;color:white">{{ list[1].displayName }}</p>
            <p style="text-align: center;color:white">{{ list[1].amount }}</p>
          </div>
          <div class="content-top-img-center">
            <van-image round style=" width: 1.5rem;
          height: 1.5rem;
          border-radius: 50%;" :src="list[0].avatarUrl"
              error-icon="http://www.weopinions.com/images/photo/default.gif" />
            <img class='tara-icon' src="../../assets/img/金冠.png" alt="">
            <p  style="text-align: center;color:white">{{ list[0].displayName }}</p>
            <p  style="text-align: center;color:white">{{ list[0].amount }}</p>
          </div>

          <div class="content-top-img-right">
          <van-image round style=" width: 1.2rem;
          height: 1.2rem;
          border-radius: 50%;" :src="list[2].avatarUrl"
              error-icon="http://www.weopinions.com/images/photo/default.gif" />
            <img class='tara1-icon' src="../../assets/img/铜冠.png" alt="">
            <p  style="text-align: center;color:white">{{ list[2].displayName }}</p>
            <p  style="text-align: center;color:white">{{ list[2].amount }}</p>
          </div>
        </div>
        <div class="content-top" v-show="!list[0].userName">
          <van-image width="100" height="100" :src="nodataImg" />
        </div>

        <div class="content-body" v-if="listTwo.length > 0">
          <div v-for="(item, index) in listTwo" class="card-list" :key="index">
            <van-image round width="1rem" height="1rem" :src="item.avatarUrl"
              error-icon="http://www.weopinions.com/images/photo/default.gif" />
            <div class="content-body-div">
              <div>{{ item.userName }}</div>
              <div>{{ item.displayName }}</div>
              <div>{{ item.amount }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Ranking } from '@/api/api.js';
import { Notify } from 'vant';
import TopBar from '@/common/top-bar/index.vue'
import img from '@/assets/img/无数据.png'

export default {
  name: 'ReadRecommend',
  components: {
    TopBar
  },
  data() {
    return {
      title: this.$t("helpEarn.shieryue"),
      list: [{ avatarUrl: "" }, { avatarUrl: "" }, { avatarUrl: "" }],
      listTwo: [],
      nodataImg: img,
      loading: true
    }
  },
  methods: {
    initPage() {
      let params = {}
      Ranking(params).then(res => {
        if (res.code === 200) {
          const copyArr = JSON.parse(JSON.stringify(res.data.list))
          this.list = copyArr.slice(0, 3);
          const listTwo = copyArr.splice(3, copyArr.length)
          this.listTwo = listTwo;
          console.log(111111111);
          setTimeout(() => {
            this.loading = false
          }, 1000)
        } else {
          setTimeout(() => {
            this.loading = false
          }, 1000)
          if (res.errors[0]) {
            Notify({ type: 'danger', message: res.errors[0] });
          }
        }
      })
    }
  },
  mounted() {
    this.initPage()
  },
  activated() {
  }
}
</script>

<style lang="stylus" scoped>
  /deep/.read-recommend{
    background: url('../../assets/img/月度推荐-bg.png') ;
    background-size:100% 100%;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: #F3F3F3;
    .header{
    }
    .content{
      height: calc(100% - 50px)
      padding:20px
      box-sizing:border-box
      .content-top{
        display:flex;
        justify-content:space-around;
        margin-top:20%
        .content-top-img-left{
          height:60px;
          width:60px;
          border-radius:50%;
          background-size:100% 100% !important;
          position:relative;
          span{
            color:#fff;
            font-size:16px;
          }
          .van-image__error-icon{
            font-size: 1.2rem;
          }
          .tara1-icon{
            margin-top:-40px;
            width:60px;
            height:60px;
            position: absolute;
    top: 0;
    left: 0;
          }
        }
        .content-top-img-center{
          height:80px;
          width:80px;
          background-size:100% 100% !important;
         position:relative;
          span{
            color:#fff;
            font-size:16px;
          }
          .van-image__error-icon{
            font-size: 1.5rem;
          }
          .tara-icon{
            margin-top:-60px;
            width:80px;
            height:80px;
            position: absolute;
    top: 0;
    left: 0;
          }
        }
        .content-top-img-right{
          height:60px;
          width:60px;
          border-radius:50%;
          background-size:100% 100% !important;
          position:relative;
          span{
            color:#fff;
            font-size:16px;
          }
          .van-image__error-icon{
            font-size: 1.2rem;
          }
          .tara1-icon{
            margin-top:-40px;
            width:60px;
            height:60px;
            position: absolute;
    top: 0;
    left: 0;
          }
        }

      }
      .content-body{
        margin-top:15%
        border-radius:10px
        background:#fff;
        padding: 15px 10px 15px 15px;
        max-height:350px;
        overflow:auto;
        .van-image__error-icon{
          font-size: 1rem;
        }
        .card-list{
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: .2rem;
          .content-body-div{
            width: 75%;
            display:flex;
            justify-content:space-between;
            font-size:12px;
            padding:10px;
          }
        }

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/readRecommend/ReadRecommend.vue